import styled from 'styled-components';

interface LayoutProps {
  height?: string;
  width?: string;
  size?: string;
  top?: string;
  right?: string;
  bottom?: string;
  left?: string;
  color?: string;
  angle?: string;
  margin?: string;
  mobileMargin?: string;
  border?: string;
}

export const Oval = styled.div`
  border-radius: 80px;
  height: 33px;
  width: 90px;
  color: ${({ theme }) => theme.color.white};
  size: 33px;
  border: 1px solid ${({ theme }) => theme.color.darkBlue};
  text-align: center;
  transition: transform 0.3s ease-in-out;
  :hover {
    background-color: ${({ theme }) => theme.color.darkBlue};
    cursor: pointer;
    transform: scale(1.1);
  }
`;

export const HalfLeftOval = styled.div`
  width: 53px;
  height: 40px;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  background-color: ${({ theme }) => theme.color.darkBlue};
  display: flex;
  justify-content: center;
  align-items: center;
  right: 0;
  margin: 0 0.2rem 0 0;
`;
export const HalfRightOval = styled.div`
  width: 53px;
  height: 40px;
  right: 0;
  border-top-right-radius: 100px;
  border-bottom-right-radius: 100px;
  background-color: ${({ theme }) => theme.color.darkBlue};
  margin: 0 2rem 2rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BottomRightTriangle = styled.div`
  position: absolute;
  top: ${(props: LayoutProps) => props.top || ''};
  right: ${(props: LayoutProps) => props.right || ''};
  bottom: ${(props: LayoutProps) => props.bottom || ''};
  left: ${(props: LayoutProps) => props.left || ''};
  width: ${(props: LayoutProps) => props.size || '100px'};
  height: ${(props: LayoutProps) => props.size || '100px'};
  margin: ${(props: LayoutProps) => props.margin || ''};
  background-color: ${(props: LayoutProps) => props.color || '#000'};
  clip-path: polygon(0% 100%, 100% 100%, 100% 0%);
  @media ${({ theme }) => theme.device.tablet} {
    margin: ${(props: LayoutProps) => props.mobileMargin || props.margin || ''};
  }
`;

export const Circle = styled.div`
  position: absolute;
  border-radius: 50%;
  top: ${(props: LayoutProps) => props.top || ''};
  right: ${(props: LayoutProps) => props.right || ''};
  bottom: ${(props: LayoutProps) => props.bottom || ''};
  left: ${(props: LayoutProps) => props.left || ''};
  width: ${(props: LayoutProps) => props.size || '100px'};
  height: ${(props: LayoutProps) => props.size || '100px'};
  margin: ${(props: LayoutProps) => props.margin || ''};
  border: ${(props: LayoutProps) => props.border || ''};
  background-color: ${(props: LayoutProps) => props.color || '#000'};
  @media ${({ theme }) => theme.device.tablet} {
    margin: ${(props: LayoutProps) => props.mobileMargin || props.margin || ''};
  }
`;

export const RotatedSquare = styled.div`
  position: absolute;
  top: ${(props: LayoutProps) => props.top || ''};
  right: ${(props: LayoutProps) => props.right || ''};
  bottom: ${(props: LayoutProps) => props.bottom || ''};
  left: ${(props: LayoutProps) => props.left || ''};
  width: ${(props: LayoutProps) => props.size || '100px'};
  height: ${(props: LayoutProps) => props.size || '100px'};
  margin: ${(props: LayoutProps) => props.margin || ''};
  background-color: ${(props: LayoutProps) => props.color || '#000'};
  transform: rotate(${(props: LayoutProps) => props.angle || '45deg'});
  @media ${({ theme }) => theme.device.tablet} {
    margin: ${(props: LayoutProps) => props.mobileMargin || props.margin || ''};
  }
`;
